import { call } from 'redux-saga/effects';

import { fetchBoardByCurrentPath } from './boards';
import request from '../request';
import api from '../../../api';
import mergeRecords from '../../../utils/merge-records';

export function* fetchCore() {
  const {
    item: user,
    included: { permissions, roles, rolePermissions, userRoleAssignments },
  } = yield call(request, api.getCurrentUser, true);

  console.log(' API getCurrentUser RESULT', {
    permissions,
    roles,
    rolePermissions,
    userRoleAssignments,
  });

  const {
    items: projects1,
    included: {
      users: users1,
      projectManagers,
      boards,
      boardMemberships: boardMemberships1,
      folders: folders1,
      userBoardPreferences: userBoardPreferences1,
    },
  } = yield call(request, api.getProjects);

  console.log('FETCH CORE RESULT', {
    items: projects1,
    users: users1,
    projectManagers,
    boards,
    folders: folders1,
    boardMemberships: boardMemberships1,
    userBoardPreferences: userBoardPreferences1,
  });

  let board;
  let card;
  let boardUsers;
  let labels;
  let lists;
  let cards1;
  let cardMemberships;
  let cardLabels;
  let attachments;
  let cardRelations;
  // let permissions;

  try {
    ({
      board,
      card,
      boardUsers,
      labels,
      lists,
      cards: cards1,
      cardMemberships,
      cardLabels,
      attachments,
      cardRelations,
    } = yield call(fetchBoardByCurrentPath));
  } catch {} // eslint-disable-line no-empty

  const body = yield call(request, api.getNotifications);

  let { items: notifications } = body;

  const {
    included: { users: users3, cards: cards2, activities },
  } = body;

  if (card) {
    const notificationIds = notifications.flatMap((notification) =>
      notification.cardId === card.id ? [notification.id] : [],
    );

    if (notificationIds.length > 0) {
      yield call(request, api.updateNotifications, notificationIds, {
        isRead: true,
      });

      notifications = notifications.filter(
        (notification) => !notificationIds.includes(notification.id),
      );
    }
  }

  console.log('FETCH CORE RESULT de getCurrentUser', {
    permissions,
    roles,
    rolePermissions,
    userRoleAssignments,
  });

  return {
    user,
    board,
    users: mergeRecords(users1, boardUsers, users3),
    projects: projects1,
    projectManagers,
    boards,
    folders: folders1 || [],
    userBoardPreferences: userBoardPreferences1 || [],
    boardMemberships: boardMemberships1,
    labels,
    lists,
    cards: mergeRecords(cards1, cards2),
    cardMemberships,
    cardLabels,
    attachments,
    activities,
    notifications,
    cardRelations,
    permissions,
    roles,
    rolePermissions,
    userRoleAssignments,
  };
}

export default {
  fetchCore,
};
